export default __webpack_public_path__ + "static/media/code_arduino.31b8fe3a.jpg";